import {createSvgIcon} from '../create-svg-icon';

export const ArrowDropDownIcon = createSvgIcon(
  <path d="m7 10 5 5 5-5H7z" />
, 'ArrowDropDownOutlined');
